const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getValidationRulesCatalog(filters = {}) {
  const params = new URLSearchParams();
  if (filters.category) params.append('category', filters.category);
  if (filters.severity) params.append('severity', filters.severity);
  
  const queryString = params.toString();
  const url = `${API_BASE}/validation-rules${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch validation rules');
  }
  
  const data = await response.json();
  return data.validationRules;
}

export async function getValidationRule(ruleId) {
  const response = await fetch(`${API_BASE}/validation-rules/${ruleId}`, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch validation rule');
  }
  
  const data = await response.json();
  return data.validationRule;
}

export async function getProfileValidationConfig(orgId, profileId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/validation-config`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch validation config');
  }
  
  const data = await response.json();
  return data.validationConfig;
}

export async function setProfileValidationConfig(orgId, profileId, configs) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/validation-config`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ configs })
  });
  
  if (!response.ok) {
    throw new Error('Failed to update validation config');
  }
  
  const data = await response.json();
  return data.validationConfig;
}

export async function runValidation(orgId, profileId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/report-profiles/${profileId}/validate`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ data })
  });
  
  if (!response.ok) {
    throw new Error('Failed to run validation');
  }
  
  return response.json();
}
